/**
 *  get merge and uniq
 * @param arr1
 * @param arr2
 * @return {*}
 */
const mergeAndUniq = (arr1, arr2) => arr1.concat(arr2.filter((item) => arr1.indexOf(item) < 0))

export default mergeAndUniq
